import services from "../../../http/index";
import * as types from "./mutations-types";

export const ActionDoGetCustomers = ({ commit }, payload = null) => {
    return services.api.request({
        url: "customers",
        method: "get",
        params: payload
    }).then(response => {
        if (!payload) {
            commit(types.SET_CUSTOMERS_LIST, response.data);
        }
        return response.data;
    });
};

export const ActionDoGetCustomer = (context, customer_id) => {
    return services.api.request({
        url: `customers/${customer_id}`,
        method: "get"
    }).then(response => {
        return response.data;
    });
};

export const ActionDoCreateCustomer = (context, payload) => {
    return services.api.request({
        url: "customers",
        method: "post",
        data: payload
    }).then(response => {
        return response.data;
    });
};

export const ActionDoUpdateCustomer = (context, payload) => {
    return services.api.request({
        url: `customers/${payload.customer_id}`,
        method: "put",
        data: payload
    }).then(response => {
        return response.data;
    });
};

export const ActionDoDeleteCustomer = (context, customer_id) => {
    return services.api.request({
        url: `customers/${customer_id}`,
        method: "delete"
    }).then(response => {
        return response.data;
    });
};

export const ActionDoGetEmergencyContactsCustomer = (context, payload) => {
    return services.api.request({
        url: `emergency-contact/list`,
        method: "post",
        data: payload
    }).then(response => {
        return response.data;
    });
};

export const ActionDoCreateEmergencyContact = (context, payload) => {
    return services.api.request({
        url: "emergency-contact",
        method: "post",
        data: payload
    }).then(response => {
        return response.data;
    });
};

export const ActionDoUpdateEmergencyContact = (context, payload) => {
    return services.api.request({
        url: `emergency-contact/${payload.contact_id}`,
        method: "put",
        data: payload
    }).then(response => {
        return response.data;
    });
};

export const ActionDoDeleteEmergencyContact = (context, contact_id) => {
    return services.api.request({
        url: `emergency-contact/${contact_id}`,
        method: "delete"
    }).then(response => {
        return response.data;
    });
};

export const ActionDoGenerateContract = (context, payload) => {
    return services.api.request({
        url: "contract",
        method: "post",
        data: payload
    }).then(response => {
        return response.data;
    });
};

export const ActionDoUpdateContract = (context, payload) => {
    return services.api.request({
        url: `contract/${payload.contract_id}`,
        method: "put",
        data: payload
    }).then(response => {
        return response.data;
    });
};

export const ActionDoCheckCustomerExists = (context, payload) => {
    return services.api.request({
        url: "customers/check-customer",
        method: "post",
        data: payload
    }).then(response => {
        return response.data;
    });
};

export const ActionDoSignContract = (context, payload) => {
    return services.api.request({
        url: "contract/sign",
        method: "post",
        data: payload,
        headers: {
            "Content-Type": "multipart/form-data"
        },
    }).then(response => {
        return response.data;
    })
}

export const ActionDoGetSignedContract = (context, contract_id) => {
    return services.api.request({
        url: `contract/signed`,
        data: { contract_id: contract_id },
        method: "post",
    }).then(response => {
        return response.data;
    })
};

/**
 * Cancel a contract
 * @param {Object} context vuex context
 * @param {String} contract_id contract id to cancel
 * @returns {Promise} promise with the response data
 */
export const ActionDoCancelContract = (context, contract_id) => {
    return services.api.request({
        url: `contract/cancel`,
        data: { contract_id: contract_id },
        method: "post",
    }).then(response => {
        return response.data;
    })
};

/**
 * Finish a contract
 * @param {Object} context vuex context
 * @param {String} contract_id contract id to finish
 * @returns {Promise} promise with the response data
 */
export const ActionDoFinishContract = (context, contract_id) => {
    return services.api.request({
        url: `contract/finish`,
        data: { contract_id: contract_id },
        method: "post",
    }).then(response => {
        return response.data;
    })
};